type ApiCustomerContext = {
  isLangguth: boolean
  selectedCustomerId: string | null
}

let apiCustomerContext: ApiCustomerContext = {
  isLangguth: false,
  selectedCustomerId: null,
}

export function setApiCustomerContext(next: ApiCustomerContext) {
  apiCustomerContext = next
}

export function applyCustomerContextHeader(request: Request): Request {
  if (
    !apiCustomerContext.isLangguth ||
    !apiCustomerContext.selectedCustomerId
  ) {
    return request
  }
  const headers = new Headers(request.headers)
  headers.set('X-Customer-Id', apiCustomerContext.selectedCustomerId)
  return new Request(request, { headers })
}
